import React, { useRef, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
// import "swiper/css/pagination";

import Blog_image from "../../images/Blog/Blog_image.png";
import Profile_avatar from "../../images/Blog/avatar.png";
import Arrow from "../../images/Blog/arrow.png";
import Card_img from "../../images/Blog/blog_cardimg.png";
import previous from "../../images/Blog/previous.png";
import next from "../../images/Blog/next.png";
import Home_image from "../../images/Blog/home_img.png";
// Components
import Blog_filter from "../../Components/Blog/Filter";
import Button from "../../Components/Button";
import Chatwithus from "../../Components/chatwithus";
import Dream_Property from "../../Components/Blog/DreamProperty";
import { useNavigate } from "react-router-dom";
import useFetch from "../../hooks/useFetch";

function Blog() {
  const [properties, setProperties] = useState();
  const navigate = useNavigate();

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const prevmobRef = useRef(null);
  const nextmobRef = useRef(null);
  const prevmevRef = useRef(null);
  const nextmevRef = useRef(null);
  const [swiperInitialisation, setSwiperInitialisation] = useState(false);

  useEffect(() => {
    console.log("Barath");
  }, [swiperInitialisation]);

  const { data } = useFetch("http://localhost:1337/api/properties?populate=*");
  const handleItemClick = (item) => {
    navigate(`/blogdescription/${item.propertyID}`, {
      state: { property: item },
    });
  };
  useEffect(() => {
    if (data) {
      setProperties(data?.data);
    }
  }, [data]);
  console.log(properties);
  return (
    <>
      <Blog_filter />

      {/* Banner */}
      <div className="max-w-[1300px] mx-auto h-fit font-alibaba px-6 my-[80px]">
        <div
          className="flex flex-wrap justify-between gap-y-6 "
          onClick={() => handleItemClick(properties[0])}
        >
          <div className="relative">
            {properties &&
              properties[0]?.image?.length > 0 &&
              properties[0]?.image[0]?.url && (
                <img
                  className="sm:w-[618px] sm:h-[484px] mx-auto "
                  src={`http://localhost:1337${
                    properties && properties[0]?.image[0].url
                  }`}
                  alt="Blog_image"
                />
              )}
            <p className="absolute top-4 right-4 bg-yellow px-4 py-2">
              {properties && properties[0]?.category}
            </p>
          </div>
          <div className="max-w-[570px] m-auto">
            <h1 className="text-[35px] font-bold sm:leading-[55px] sm:text-[45px]">
              {properties && properties[0]?.heading}
            </h1>

            <div className="flex items-center gap-x-[15px] my-[25px]">
              <img
                className="w-[40px]"
                src={Profile_avatar}
                alt="Profile_avatar"
              />
              <p className="text-font-grey text-[16px]">
                {properties && properties[0]?.user}
              </p>
            </div>

            <p className="text-font-grey text-[20px] leading-[30px] mb-[60px]">
              {properties && properties[0]?.content}
            </p>

            <Button
              name={"Learn more"}
              design={"filled"}
              action={"internal-linking"}
              pageLink={"/blogdescription"}
            />
          </div>
        </div>
      </div>

      {/* Buying */}
      <div className="max-w-fit xl:max-w-[1260px] mx-auto font-alibaba mt-[80px] lg:mt-[150px] px-6 lg:px-0 relative">
        {/* Heading */}
        <h2 className="text-[30px] font-bold sm:text-[35px]">Buying Guides</h2>

        {/* Looping  */}
        <Swiper
          modules={[Navigation]}
          spaceBetween={20}
          slidesPerView={3}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          // pagination={{ clickable: true }}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="overflow-visible mt-12"
          onInit={() => {
            setSwiperInitialisation(true);
          }}
        >
          {properties &&
            properties
              .filter((item) => item.category === "Buying")
              .map((items) => (
                <SwiperSlide>
                  <div
                    className="w-[399px] h-fit mx-auto border border-[#E3E4E4] rounded-[4px] shadow-lg relative"
                    onClick={() => handleItemClick(items)}
                  >
                    {items.image?.length > 0 && items.image[0]?.url && (
                      <img
                        className="w-full h-[229px] relative"
                        src={`http://localhost:1337${items.image[0].url}`}
                        alt="Profile_avatar"
                      />
                    )}

                    <p className="absolute right-4 top-4 bg-yellow px-4 py-1">
                      {items.category}
                    </p>

                    <div className="p-[28px]">
                      <h1 className="text-[24px] font-bold">{items.heading}</h1>

                      <div className="flex items-center gap-x-[15px] mt-[22px] mb-[25px]">
                        <p className="text-font-grey text-[16px]">
                          {items.user}
                        </p>
                      </div>
                      <p className="text-[16px] text-font-grey leading-[23px]">
                        {items.content.slice(0, 150)}
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
        </Swiper>
        <div className="flex flex-row items-center gap-x-1 absolute top-3 right-3">
          <button ref={prevRef} className=" p-1 rounded opacity-70">
            <img src={previous} alt="Previous" className="w-[24px] h-[24px] " />
          </button>
          <button ref={nextRef} className=" p-1 rounded opacity-70 ">
            <img src={next} alt="Next" className="w-[24px] h-[24px]" />
          </button>
        </div>
      </div>

      {/* Workplace Trends */}
      <div className="max-w-fit xl:max-w-[1260px] mx-auto font-alibaba mt-[80px] lg:mt-[150px] px-6 lg:px-0 relative">
        {/* Heading */}

        <h2 className="text-[30px] font-bold sm:text-[35px]">
          Workplace Trends
        </h2>

        {/* Looping  */}

        <Swiper
          modules={[Navigation]}
          spaceBetween={20}
          slidesPerView={3}
          navigation={{
            prevEl: prevmobRef.current,
            nextEl: nextmobRef.current,
          }}
          // pagination={{ clickable: true }}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="overflow-visible mt-12"
          onInit={() => {
            setSwiperInitialisation(true);
          }}
        >
          {properties &&
            properties
              .filter((item) => item.category === "Workplace")

              .map((items) => (
                <SwiperSlide>
                  <div
                    className="w-[399px] h-fit mx-auto border border-[#E3E4E4] rounded-[4px] shadow-lg"
                    onClick={() => handleItemClick(items)}
                  >
                    {items.image?.length > 0 && items.image[0]?.url && (
                      <img
                        className="w-full h-[229px] "
                        src={`http://localhost:1337${items.image[0].url}`}
                        alt={items.alt}
                      />
                    )}
                    <p className="absolute right-4 top-4 bg-yellow px-4 py-1">
                      {items.category}
                    </p>
                    {/* Content */}
                    <div className="p-[28px]">
                      <h1 className="text-[24px] font-bold">{items.heading}</h1>

                      <div className="flex items-center gap-x-[15px] mt-[22px] mb-[25px]">
                        <img
                          className="w-[40px]"
                          src={Profile_avatar}
                          alt="Profile_avatar"
                        />

                        <p className="text-font-grey text-[16px]">
                          {items.user}
                        </p>
                      </div>
                      <p className="text-[16px] text-font-grey leading-[23px]">
                        {items.content.slice(0, 150)}
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
        </Swiper>
        <div className="flex flex-row items-center gap-x-1 absolute top-3 right-3">
          <button ref={prevmobRef} className=" p-1 rounded opacity-70">
            <img src={previous} alt="Previous" className="w-[24px] h-[24px] " />
          </button>
          <button ref={nextmobRef} className=" p-1 rounded opacity-70 ">
            <img src={next} alt="Next" className="w-[24px] h-[24px]" />
          </button>
        </div>
      </div>

      {/* Dream home */}
      <div className="bg-brown py-[70px] my-[80px] md:my-[150px]">
        <div className="max-w-[1180px] mx-auto flex flex-wrap gap-y-10">
          <div className="max-w-[420px] m-auto text-center px-6 lg:text-left lg:px-0">
            <h1 className="text-[45px] text-yellow font-semibold leading-[55px]">
              Ready to find your Dream Home?
            </h1>

            <p className="text-font-grey text-white text-[20px] leading-[30px] mt-[20px] mb-[60px]">
              Lorem ipsum dolor sit amet consectetur. Ipsum justo imperdiet elit
              nunc amet urna. Sem dictum vestibulum arcu velit hendrerit tellus
              vitae tortor.{" "}
            </p>

            <Button
              name={"Get Started Today"}
              design={"filled"}
              action={"external-linking"}
              url={`#`}
            />
          </div>

          <img
            className="mx-auto order-first lg:order-last"
            src={Home_image}
            alt="Home_bg"
          />
        </div>
      </div>

      {/* Neighborhood Guides */}
      <div className="max-w-fit xl:max-w-[1260px] mx-auto font-alibaba mt-[80px] lg:mt-[150px] px-6 lg:px-0 relative">
        {/* Heading */}
        <h2 className="text-[30px] font-bold sm:text-[35px]">
          Neighbourhood Guides
        </h2>

        {/* Looping  */}

        <Swiper
          modules={[Navigation]}
          spaceBetween={20}
          slidesPerView={3}
          navigation={{
            prevEl: prevmevRef.current,
            nextEl: nextmevRef.current,
          }}
          // pagination={{ clickable: true }}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="overflow-visible mt-12"
          onInit={() => {
            setSwiperInitialisation(true);
          }}
        >
          {properties &&
            properties
              .filter((item) => item.category === "Neighbourhood")

              .map((items) => (
                <SwiperSlide>
                  <div
                    className="w-[399px] h-fit mx-auto border border-[#E3E4E4] rounded-[4px] shadow-lg"
                    onClick={() => handleItemClick(items)}
                  >
                    {items.image?.length > 0 && items.image[0]?.url && (
                      <img
                        className="w-full h-[229px] "
                        src={`http://localhost:1337${items.image[0].url}`}
                        alt={items.alt}
                      />
                    )}
                    <p className="absolute right-4 top-4 bg-yellow px-4 py-1">
                      {items.category}
                    </p>
                    <div className="p-[28px]">
                      <h1 className="text-[24px] font-bold">{items.heading}</h1>

                      <div className="flex items-center gap-x-[15px] mt-[22px] mb-[25px]">
                        <img
                          className="w-[40px]"
                          src={Profile_avatar}
                          alt="Profile_avatar"
                        />
                        <p className="text-font-grey text-[16px]">
                          {items.user}
                        </p>
                      </div>
                      <p className="text-[16px] text-font-grey leading-[23px]">
                        {items.content.slice(0, 150)}
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
        </Swiper>
        <div className="flex flex-row items-center gap-x-1 absolute top-3 right-3">
          <button ref={prevmevRef} className=" p-1 rounded opacity-70">
            <img src={previous} alt="Previous" className="w-[24px] h-[24px] " />
          </button>
          <button ref={nextmevRef} className=" p-1 rounded opacity-70 ">
            <img src={next} alt="Next" className="w-[24px] h-[24px]" />
          </button>
        </div>
      </div>

      <Chatwithus />

      {/* Old Blogs */}
      <div className="hidden">
        {/* Buying */}
        <div className="font-[lato] max-w-[1197px] mx-auto mt-[78px] px-4 sm:px-0">
          <div className="flex justify-between gap-x-[50%] sm:justify-center xl:justify-between">
            <h2 className="text-[22px] font-[800] leading-[22px] tracking-[1px]">
              Buying
            </h2>
            <button className="text-[16px] font-[800] leading-[22px] tracking-[1px]">
              See all
            </button>
          </div>

          {/* <div className="flex flex-wrap justify-center gap-x-10 gap-y-[47px] mt-[21px]">
            {Buying_card.map((items) => {
              return (
                <div className="flex mx-auto w-[577px] h-[167px] border-[1.084px] border-[#EBEAEA] rounded-[4px] shadow-md lg:mx-0">
                  <img
                    className="w-[50%] object-cover sm:w-[264px] sm:h-[167px] rounded-l-[4px]"
                    src={items.src}
                    alt={items.alt}
                  />

                  <div className="my-auto ml-[15px] sm:ml-[21px]">
                    <button className="bg-[#FFF7DE] text-black text-[10px] font-semibold leading-[12px] tracking-[0.32px] px-2 py-1 rounded-[2px]">
                      8 min read
                    </button>
                    <h2 className="text-[16.2px] font-semibold leading-[23.8px] tracking-[0.3px] mt-[12px]">
                      {items.heading}
                    </h2>
                  </div>
                </div>
              );
            })}
          </div> */}
        </div>

        {/* Workplace */}
        <div className="font-[lato] max-w-[1197px] mx-auto mt-[90px] px-4 sm:mt-[138px] sm:px-0 ">
          <div className="flex justify-between gap-x-[50%] sm:justify-center xl:justify-between">
            <h2 className="text-[22px] font-[800] leading-[22px] tracking-[1px]">
              Workplace
            </h2>
            <button className="text-[16px] font-[800] leading-[22px] tracking-[1px]">
              See all
            </button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-10 gap-y-10 mt-[21px]">
            <div className="max-w-[578px] mx-auto sm:h-[595px] border-[1px] border-[#EBEAEA] rounded-[8px] shadow-md pb-8 lg:mx-0">
              <img
                className="sm:w-[577px] sm:h-[381px] rounded-t-[4px]"
                src={Blog_image}
                alt="Blog_image"
              />

              <div className="max-w-[525px] mt-[28px] px-4 sm:px-[28px]">
                <button className="bg-black text-white text-[10px] font-medium leading-[12px] tracking-[0.32px] px-2 py-1 rounded-[2px]">
                  Buying
                </button>
                <button className="bg-[#FFF7DE] text-black text-[10px] font-medium leading-[12px] tracking-[0.32px] px-2 py-1 rounded-[2px] ml-2">
                  8 min read
                </button>
                <p className="text-[24.2px] font-[800] leading-[28px] tracking-[0.81px] my-3">
                  Lorem ipsum dolor sit amet <br /> consectetur Consectetur
                </p>
                <p className="max-w-[507px] text-[#575857] text-[15px] font-[400] leading-[22px] tracking-[0.32px]">
                  Lorem ipsum dolor sit amet consectetur. Ipsum justo imperdiet
                  elit nunc amet urna. Sem dictum vestibulum arcu velit
                  hendrerit tellus vitae tortor.{" "}
                </p>
              </div>
            </div>
            {/* 
            <div className="max-w-[577px] mx-auto flex flex-col gap-y-[47px] mt-12 lg:mt-0 lg:mx-0">
              {Work_place.map((items) => {
                return (
                  <div className="flex mx-auto w-full h-[167px] border-[1.084px] border-[#EBEAEA] rounded-[4px] shadow-md sm:w-[577px] lg:mx-0">
                    <img
                      className="w-[50%] object-cover sm:w-[264px] sm:h-[167px] rounded-l-[4px]"
                      src={items.src}
                      alt={items.alt}
                    />

                    <div className="my-auto ml-[15px] sm:ml-[21px]">
                      <button className="bg-[#FFF7DE] text-black text-[10px] font-semibold leading-[12px] tracking-[0.32px] px-2 py-1 rounded-[2px]">
                        8 min read
                      </button>
                      <h2 className="text-[16.2px] font-semibold leading-[23.8px] tracking-[0.3px] mt-[12px]">
                        {items.heading}
                      </h2>
                    </div>
                  </div>
                );
              })}
            </div> */}
          </div>
        </div>

        {/* Download Report */}
        <div className="bg-[#FFF8E2] max-w-full h-max mt-[140px] py-[62px] px-4  sm:px-0">
          <div className="max-w-[1197px] mx-auto flex flex-wrap justify-between gap-y-6">
            <div className="max-w-[525px] mx-auto my-auto">
              <p className="text-[30px] font-bold leading-[35px] tracking-[1px] my-3">
                Lorem ipsum dolor sit amet consectetur Consectetur
              </p>
              <p className="max-w-[477px] text-[#575857] text-[15px] font-[400] leading-[22px] tracking-[0.32px]">
                Lorem ipsum dolor sit amet consectetur. Ipsum justo imperdiet
                elit nunc amet urna. Sem dictum vestibulum arcu velit hendrerit
                tellus vitae tortor.{" "}
              </p>
              <button className="bg-yellow text-[15px] font-bold leading-[22px] tracking-[0.32px] px-[15px] py-[8px] rounded-[4px] mt-[28px]">
                Download Report
              </button>
            </div>

            <img
              className="sm:w-[584px] sm:h-[342px] rounded-[16px] mx-auto order-first lg:order-last"
              src={Blog_image}
              alt="Blog_image"
            />
          </div>
        </div>

        {/* Types of Home */}
        <div className="font-[lato] max-w-[1197px] mx-auto mt-[90px] px-4 sm:mt-[138px] sm:px-0 ">
          <div className="flex justify-between sm:gap-x-[50%] sm:justify-center xl:justify-between">
            <h2 className="text-[22px] font-[800] leading-[22px] tracking-[1px]">
              Types of Homes
            </h2>
            <button className="text-[16px] font-[800] leading-[22px] tracking-[1px]">
              See all
            </button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-10 gap-y-10 mt-[21px]">
            <div className="max-w-[578px] mx-auto sm:h-[595px] border-[1px] border-[#EBEAEA] rounded-[8px] shadow-md pb-8 lg:mx-0">
              <img
                className="sm:w-[577px] sm:h-[381px] rounded-t-[4px]"
                src={Blog_image}
                alt="Blog_image"
              />

              <div className="max-w-[525px] mt-[28px] px-4 sm:px-[28px]">
                <button className="bg-black text-white text-[10px] font-medium leading-[12px] tracking-[0.32px] px-2 py-1 rounded-[2px]">
                  Buying
                </button>
                <button className="bg-[#FFF7DE] text-black text-[10px] font-medium leading-[12px] tracking-[0.32px] px-2 py-1 rounded-[2px] ml-2">
                  8 min read
                </button>
                <p className="text-[24.2px] font-[800] leading-[28px] tracking-[0.81px] my-3">
                  Lorem ipsum dolor sit amet <br /> consectetur Consectetur
                </p>
                <p className="max-w-[507px] text-[#575857] text-[15px] font-[400] leading-[22px] tracking-[0.32px]">
                  Lorem ipsum dolor sit amet consectetur. Ipsum justo imperdiet
                  elit nunc amet urna. Sem dictum vestibulum arcu velit
                  hendrerit tellus vitae tortor.{" "}
                </p>
              </div>
            </div>

            {/* Dream home */}
            {/* <div className='bg-brown py-[70px] my-[80px] md:my-[150px]'>
                <div className="max-w-[1180px] mx-auto flex flex-wrap gap-y-10">
                    <div className='max-w-[420px] m-auto text-center px-6 lg:text-left lg:px-0'>
                        <h1 className='text-[45px] text-yellow font-semibold leading-[55px]'>Ready to find your Dream Home?</h1>

                    <div className="my-auto ml-[15px] sm:ml-[21px]">
                      <button className="bg-[#FFF7DE] text-black text-[10px] font-semibold leading-[12px] tracking-[0.32px] px-2 py-1 rounded-[2px]">
                        8 min read
                      </button>
                      <h2 className="text-[16.2px] font-semibold leading-[23.8px] tracking-[0.3px] mt-[12px]">
                        {items.heading}
                      </h2>
                    </div>
                  </div>
                );
              })}
            </div> */}
          </div>
        </div>

        {/* Neighbourhood */}
        <div className="font-[lato] max-w-[1197px] mx-auto mt-[163px] mb-[103px] px-6 lg:px-0">
          <div className="flex justify-between sm:gap-x-[50%] sm:justify-center xl:justify-between">
            <h2 className="text-[22px] font-[800] leading-[22px] tracking-[1px]">
              Neighbourhood
            </h2>
            <button className="text-[16px] font-[800] leading-[22px] tracking-[1px]">
              See all
            </button>
          </div>

          {/* <div className="mt-[21px] flex flex-wrap justify-center gap-x-6 gap-y-10">
            {Work_place.map((items) => {
              return (
                <div className="max-w-[383px] mx-auto h-[360px] border-[1px] border-[#EBEAEA] rounded-[8px] shadow-md">
                  <img
                    className="w-[383px] h-[245px] rounded-t-[8px]"
                    src={items.src}
                    alt={items.alt}
                  />

                  <div className="my-auto mt-[21px] ml-[15px] sm:ml-[25px]">
                    <button className="bg-[#FFF7DE] text-black text-[10px] font-semibold leading-[12px] tracking-[0.32px] px-2 py-1 rounded-[2px]">
                      8 min read
                    </button>
                    <h2 className="text-[16.2px] font-semibold leading-[23.8px] tracking-[0.3px] mt-[12px]">
                      {items.heading}
                    </h2>
                  </div>
                </div>
            </div> */}

          <Dream_Property />

          {/* Neighborhood Guides */}
          <div className="max-w-[1260px] mx-auto font-alibaba mt-[80px] lg:mt-[150px] px-6 lg:px-0">
            {/* Heading */}
            <div className="w-fit mx-auto space-y-8 xl:flex items-center justify-between xl:w-full">
              <h2 className="text-[30px] font-bold sm:text-[35px]">
                Neighborhood Guides
              </h2>

              <div className="flex justify-center gap-x-2 items-center my-auto">
                <p className="text-[20px]">See All</p>
                <img className="w-[35px]" src={Arrow} alt="Arrow" />
              </div>
            </div>

            {/* Looping  */}
            {/* 
          <div className="flex flex-wrap justify-between gap-y-10 my-[40px]">
            {Buying_card.map((items) => {
              return (
                <div className="w-[399px] h-fit mx-auto border border-[#E3E4E4] rounded-[4px] shadow-lg">
                  <img src={items.src} alt={items.alt} />

                  <div className="p-[28px]">
                    <h1 className="text-[24px] font-bold">{items.heading}</h1>

                    <div className="flex items-center gap-x-[15px] mt-[22px] mb-[25px]">
                      <img
                        className="w-[40px]"
                        src={Profile_avatar}
                        alt="Profile_avatar"
                      />
                      <p className="text-font-grey text-[16px]">{items.user}</p>
                    </div>
                    <p className="text-[16px] text-font-grey leading-[23px]">
                      {items.content}
                    </p>
                  </div>
                </div>
              );
            })}
          </div> */}
          </div>

          <Chatwithus />

          {/* Old Blogs */}
          <div className="hidden">
            <div className="font-[lato] max-w-[1197px] mx-auto mt-[78px] px-4 sm:px-0">
              <div className="flex justify-between gap-x-[50%] sm:justify-center xl:justify-between">
                <h2 className="text-[22px] font-[800] leading-[22px] tracking-[1px]">
                  Buying
                </h2>
                <button className="text-[16px] font-[800] leading-[22px] tracking-[1px]">
                  See all
                </button>
              </div>

              {/* <div className="flex flex-wrap justify-center gap-x-10 gap-y-[47px] mt-[21px]">
              {Buying_card.map((items) => {
                return (
                  <div className="flex mx-auto w-[577px] h-[167px] border-[1.084px] border-[#EBEAEA] rounded-[4px] shadow-md lg:mx-0">
                    <img
                      className="w-[50%] object-cover sm:w-[264px] sm:h-[167px] rounded-l-[4px]"
                      src={items.src}
                      alt={items.alt}
                    />

                    <div className="my-auto ml-[15px] sm:ml-[21px]">
                      <button className="bg-[#FFF7DE] text-black text-[10px] font-semibold leading-[12px] tracking-[0.32px] px-2 py-1 rounded-[2px]">
                        8 min read
                      </button>
                      <h2 className="text-[16.2px] font-semibold leading-[23.8px] tracking-[0.3px] mt-[12px]">
                        {items.heading}
                      </h2>
                    </div>
                  </div>
                );
              })}
            </div> */}
            </div>

            {/* Workplace */}
            <div className="font-[lato] max-w-[1197px] mx-auto mt-[90px] px-4 sm:mt-[138px] sm:px-0 ">
              <div className="flex justify-between gap-x-[50%] sm:justify-center xl:justify-between">
                <h2 className="text-[22px] font-[800] leading-[22px] tracking-[1px]">
                  Workplace
                </h2>
                <button className="text-[16px] font-[800] leading-[22px] tracking-[1px]">
                  See all
                </button>
              </div>

              <div className="flex flex-wrap justify-center gap-x-10 gap-y-10 mt-[21px]">
                <div className="max-w-[578px] mx-auto sm:h-[595px] border-[1px] border-[#EBEAEA] rounded-[8px] shadow-md pb-8 lg:mx-0">
                  <img
                    className="sm:w-[577px] sm:h-[381px] rounded-t-[4px]"
                    src={Blog_image}
                    alt="Blog_image"
                  />

                  <div className="max-w-[525px] mt-[28px] px-4 sm:px-[28px]">
                    <button className="bg-black text-white text-[10px] font-medium leading-[12px] tracking-[0.32px] px-2 py-1 rounded-[2px]">
                      Buying
                    </button>
                    <button className="bg-[#FFF7DE] text-black text-[10px] font-medium leading-[12px] tracking-[0.32px] px-2 py-1 rounded-[2px] ml-2">
                      8 min read
                    </button>
                    <p className="text-[24.2px] font-[800] leading-[28px] tracking-[0.81px] my-3">
                      Lorem ipsum dolor sit amet <br /> consectetur Consectetur
                    </p>
                    <p className="max-w-[507px] text-[#575857] text-[15px] font-[400] leading-[22px] tracking-[0.32px]">
                      Lorem ipsum dolor sit amet consectetur. Ipsum justo
                      imperdiet elit nunc amet urna. Sem dictum vestibulum arcu
                      velit hendrerit tellus vitae tortor.{" "}
                    </p>
                  </div>
                </div>

                <div className="max-w-[577px] mx-auto flex flex-col gap-y-[47px] mt-12 lg:mt-0 lg:mx-0">
                  {/* {Work_place.map((items) => {
                  return (
                    <div className="flex mx-auto w-full h-[167px] border-[1.084px] border-[#EBEAEA] rounded-[4px] shadow-md sm:w-[577px] lg:mx-0">
                      <img
                        className="w-[50%] object-cover sm:w-[264px] sm:h-[167px] rounded-l-[4px]"
                        src={items.src}
                        alt={items.alt}
                      />

                      <div className="my-auto ml-[15px] sm:ml-[21px]">
                        <button className="bg-[#FFF7DE] text-black text-[10px] font-semibold leading-[12px] tracking-[0.32px] px-2 py-1 rounded-[2px]">
                          8 min read
                        </button>
                        <h2 className="text-[16.2px] font-semibold leading-[23.8px] tracking-[0.3px] mt-[12px]">
                          {items.heading}
                        </h2>
                      </div>
                    </div>
                  );
                })} */}
                </div>
              </div>
            </div>

            {/* Download Report */}
            <div className="bg-[#FFF8E2] max-w-full h-max mt-[140px] py-[62px] px-4  sm:px-0">
              <div className="max-w-[1197px] mx-auto flex flex-wrap justify-between gap-y-6">
                <div className="max-w-[525px] mx-auto my-auto">
                  <p className="text-[30px] font-bold leading-[35px] tracking-[1px] my-3">
                    Lorem ipsum dolor sit amet consectetur Consectetur
                  </p>
                  <p className="max-w-[477px] text-[#575857] text-[15px] font-[400] leading-[22px] tracking-[0.32px]">
                    Lorem ipsum dolor sit amet consectetur. Ipsum justo
                    imperdiet elit nunc amet urna. Sem dictum vestibulum arcu
                    velit hendrerit tellus vitae tortor.{" "}
                  </p>
                  <button className="bg-yellow text-[15px] font-bold leading-[22px] tracking-[0.32px] px-[15px] py-[8px] rounded-[4px] mt-[28px]">
                    Download Report
                  </button>
                </div>

                <img
                  className="sm:w-[584px] sm:h-[342px] rounded-[16px] mx-auto order-first lg:order-last"
                  src={Blog_image}
                  alt="Blog_image"
                />
              </div>
            </div>

            {/* Types of Home */}
            <div className="font-[lato] max-w-[1197px] mx-auto mt-[90px] px-4 sm:mt-[138px] sm:px-0 ">
              <div className="flex justify-between sm:gap-x-[50%] sm:justify-center xl:justify-between">
                <h2 className="text-[22px] font-[800] leading-[22px] tracking-[1px]">
                  Types of Homes
                </h2>
                <button className="text-[16px] font-[800] leading-[22px] tracking-[1px]">
                  See all
                </button>
              </div>

              <div className="flex flex-wrap justify-center gap-x-10 gap-y-10 mt-[21px]">
                <div className="max-w-[578px] mx-auto sm:h-[595px] border-[1px] border-[#EBEAEA] rounded-[8px] shadow-md pb-8 lg:mx-0">
                  <img
                    className="sm:w-[577px] sm:h-[381px] rounded-t-[4px]"
                    src={Blog_image}
                    alt="Blog_image"
                  />

                  <div className="max-w-[525px] mt-[28px] px-4 sm:px-[28px]">
                    <button className="bg-black text-white text-[10px] font-medium leading-[12px] tracking-[0.32px] px-2 py-1 rounded-[2px]">
                      Buying
                    </button>
                    <button className="bg-[#FFF7DE] text-black text-[10px] font-medium leading-[12px] tracking-[0.32px] px-2 py-1 rounded-[2px] ml-2">
                      8 min read
                    </button>
                    <p className="text-[24.2px] font-[800] leading-[28px] tracking-[0.81px] my-3">
                      Lorem ipsum dolor sit amet <br /> consectetur Consectetur
                    </p>
                    <p className="max-w-[507px] text-[#575857] text-[15px] font-[400] leading-[22px] tracking-[0.32px]">
                      Lorem ipsum dolor sit amet consectetur. Ipsum justo
                      imperdiet elit nunc amet urna. Sem dictum vestibulum arcu
                      velit hendrerit tellus vitae tortor.{" "}
                    </p>
                  </div>
                </div>

                <div className="max-w-[577px] mx-auto flex flex-col gap-y-[47px] mt-12 lg:mt-0 lg:mx-0">
                  {/* {Work_place.map((items) => {
                  return (
                    <div className="flex mx-auto w-full h-[167px] border-[1.084px] border-[#EBEAEA] rounded-[4px] shadow-md sm:w-[577px] lg:mx-0">
                      <img
                        className="w-[50%] object-cover sm:w-[264px] sm:h-[167px] rounded-l-[4px]"
                        src={items.src}
                        alt={items.alt}
                      />

                      <div className="my-auto ml-[15px] sm:ml-[21px]">
                        <button className="bg-[#FFF7DE] text-black text-[10px] font-semibold leading-[12px] tracking-[0.32px] px-2 py-1 rounded-[2px]">
                          8 min read
                        </button>
                        <h2 className="text-[16.2px] font-semibold leading-[23.8px] tracking-[0.3px] mt-[12px]">
                          {items.heading}
                        </h2>
                      </div>
                    </div>
                  );
                })} */}
                </div>
              </div>
            </div>

            {/* Neighbourhood */}
            <div className="font-[lato] max-w-[1197px] mx-auto mt-[163px] mb-[103px] px-6 lg:px-0">
              <div className="flex justify-between sm:gap-x-[50%] sm:justify-center xl:justify-between">
                <h2 className="text-[22px] font-[800] leading-[22px] tracking-[1px]">
                  Neighborhood
                </h2>
                <button className="text-[16px] font-[800] leading-[22px] tracking-[1px]">
                  See all
                </button>
              </div>

              <div className="mt-[21px] flex flex-wrap justify-center gap-x-6 gap-y-10">
                {/* {Work_place.map((items) => {
                return (
                  <div className="max-w-[383px] mx-auto h-[360px] border-[1px] border-[#EBEAEA] rounded-[8px] shadow-md">
                    <img
                      className="w-[383px] h-[245px] rounded-t-[8px]"
                      src={items.src}
                      alt={items.alt}
                    />

                    <div className="my-auto mt-[21px] ml-[15px] sm:ml-[25px]">
                      <button className="bg-[#FFF7DE] text-black text-[10px] font-semibold leading-[12px] tracking-[0.32px] px-2 py-1 rounded-[2px]">
                        8 min read
                      </button>
                      <h2 className="text-[16.2px] font-semibold leading-[23.8px] tracking-[0.3px] mt-[12px]">
                        {items.heading}
                      </h2>
                    </div>
                  </div>
                );
              })} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Blog;
